/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
import { DsPasswordChange } from './models/ds-password-change';
import { DsResetPassword } from './models/ds-reset-password';
/** Services */
import { BydRhsAbstractService } from '../../shared/services/byd-rhs-abstract.service';
/** Interfaces */
import { DsPasswordChangeInterface } from './interfaces/ds-password-change.interface';

@Injectable({
  providedIn: 'root',
})
export class DsPasswordService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Send the reset password email.
   *
   * @param email The email address
   * @param currentLanguage The current language
   * @param hostUrl The host url
   * @returns Observable<boolean>
   */
  public sendResetEmail(email: string, currentLanguage: string, hostUrl: string): Observable<boolean> {
    this.path = `/users/sendpasswordresetmail?email=${email}&currentLang=${currentLanguage}&hostUrl=${hostUrl}`;
    return this.get<boolean>();
  }

  /**
   * Change the user password.
   *
   * @param userToken The user token
   * @param newPassword The new password
   * @returns Observable<boolean>
   */
  public changeUserPassword(userToken: string, newPassword: string) {
    this.path = `/users/changepassword`;
    const body = new DsResetPassword({ token: userToken, password: newPassword });
    return this.postModel<boolean>({ body });
  }

  /**
   * Create new instance.
   *
   * @param jsonData the json data
   * @returns DsPasswordChange
   */
  createNewInstance(jsonData: DsPasswordChangeInterface): DsPasswordChange {
    return new DsPasswordChange(jsonData);
  }
}
